// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import router from '@/router'
import mouldRouter from '@/router/mould'
import store from '@/store'
import jquery from 'jquery'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import {
  Toast,
  Form,
  Uploader,
  Field,
  Button,
  Icon,
  Popup,
  List,
  PullRefresh,
  Empty,
  Step,
  Steps
} from 'vant'
import 'vant/lib/index.css'

const env = process.env
// console.log(env)

Vue.config.productionTip = env.DEBUG
Vue.config.silent = !env.DEBUG
Vue.config.devtools = env.DEBUG
if (env.DEBUG) {
  Vue.config.warnHandler = function (err, vm, info) {
    console.log(err)
    console.log(vm)
    console.log(info)
  }
}

Vue.prototype.$Router = mouldRouter
Vue.prototype.$_ = jquery

Vue.use(ElementUI)
// 引入vant组件
Vue.prototype.$Toast = Toast
Vue.use(Form)
Vue.use(Uploader)
Vue.use(Field)
Vue.use(Button)
Vue.use(Icon)
Vue.use(Popup)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Empty)
Vue.use(Step)
Vue.use(Steps)

window._vue = Vue

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js